import FormattedMessage from 'I18n/components/FormattedMessage';
import getRecipientName from 'documents-ui/utils/getRecipientName';
import DetailContactCard from './DetailContactCard';
import DetailViewsCard from './DetailViewsCard';
import { Button } from 'foundations-components/transitional/components/Button';
import { CloseButton } from 'foundations-components/transitional/components/CloseButton';
import { Panel, PanelSection } from 'foundations-components/transitional/components/Panel';
import { PanelBody } from 'foundations-components/transitional/components/PanelBody';
import { PanelFooter } from 'foundations-components/transitional/components/PanelFooter';
import { PanelHeader } from 'foundations-components/transitional/components/PanelHeader';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DetailPanel = ({
  deckVisitor,
  revisits,
  allDocumentSlides,
  onClose
}) => {
  const contactName = getRecipientName(deckVisitor.get('contact'));
  return /*#__PURE__*/_jsxs(Panel, {
    width: 600,
    children: [/*#__PURE__*/_jsx(CloseButton, {
      onClick: onClose
    }), /*#__PURE__*/_jsx(PanelHeader, {
      children: /*#__PURE__*/_jsx(Text, {
        as: "h4",
        color: "text-core-on-fill-default",
        children: contactName || /*#__PURE__*/_jsx(FormattedMessage, {
          message: "summary.recipientsTable.row.someone"
        })
      })
    }), /*#__PURE__*/_jsx(PanelBody, {
      children: /*#__PURE__*/_jsxs(PanelSection, {
        padding: "600",
        children: [/*#__PURE__*/_jsx(DetailContactCard, {
          contact: deckVisitor.get('contact'),
          marginBlockEnd: "400"
        }), /*#__PURE__*/_jsx(DetailViewsCard, {
          revisits: revisits,
          allDocumentSlides: allDocumentSlides,
          contact: deckVisitor.get('contact')
        })]
      })
    }), /*#__PURE__*/_jsx(PanelFooter, {
      children: /*#__PURE__*/_jsx(Button, {
        use: "primary",
        onClick: onClose,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "summary.detail.footer.close"
        })
      })
    })]
  });
};
export default DetailPanel;